import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom';
import Header from '../Component/Header';
import Sidebar from '../Component/Sidebar';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import baseUrl from '../Constant';


function EditCase() {
    const [scase, setCase] = useState()
    const [prescription, setPrescription] = useState()
    const [message, setMessage] = useState()
    const [color, setColor] = useState()
    const [loading, setLoading] = useState(false)

    const location = useLocation();
    const item = location.state?.item
    console.log(item)

    const SubmitCase = ((e) => {
        e.preventDefault()
        setLoading(true)
        const token = JSON.parse(localStorage.getItem("token"))
        const case_uid = item.uid;
        const cases = scase;
        const priscrption = prescription;
        axios.post(`${baseUrl}/accounts/case-list`, { case_uid, cases, priscrption }, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setMessage(res.data.message)
                if (res.data.status === 200) {
                    setColor("#008000");
                    setTimeout(() => {
                        setMessage('')
                        setColor('')
                    }, 2000);
                    setLoading(false)

                }
                else {
                    setColor("#ff0000");
                    console.log('red')
                    setTimeout(() => {
                        setMessage('')
                        setColor("");
                    }, 2000);
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log(error)
                setLoading(false)
            })
    })

    useEffect(() => {
        setCase(item.cases)
        setPrescription(item.priscrption)
    }, [])


    return (
        <div>
            <Header />
            <div className='d-flex'>
                <div>
                    <Sidebar />
                </div>
                <div className='container-fluid' style={{ backgroundColor: 'rgb(42 127 155 / 24%)' }}>
                    <div className='row p-3'>
                        {
                            message && <div style={{ marginBottom: 10 }}>
                                <div style={{ fontSize: 20, fontWeight: 600, color: 'white', textAlign: "center", backgroundColor: `${color}` }}>{message}</div>
                            </div>
                        }
                        <div className='col-md-12'>
                            <div className='row p-3'>
                                <div className='col-md-12'>
                                    <div className='card'>
                                        <div className='card-body'>
                                            <Form
                                                onSubmit={SubmitCase}
                                            >
                                                <Row className='mobile'>
                                                    <Form.Group as={Col}>
                                                        <Form.Label style={{ fontSize: '1.2rem', fontWeight: "500" }}>Case:</Form.Label>
                                                        <Form.Control as="textarea" rows={3} name='scases' value={scase} onChange={(e) => setCase(e.target.value)} placeholder='Enter Case' required />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                        <Form.Label style={{ fontSize: '1.2rem', fontWeight: "500" }}>Priscription</Form.Label>
                                                        <Form.Control as="textarea" rows={3} name='spriscription' placeholder='Enter Prescription' value={prescription} onChange={(e) => setPrescription(e.target.value)} required />
                                                    </Form.Group>

                                                </Row>
                                                <Button variant="primary" className='mt-3' type="submit">
                                                    Submit
                                                </Button>

                                            </Form>


                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default EditCase;